"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    box-sizing: content-box;\n    height: 0;\n    margin: 0;\n    width: 100%;\n    border-width: medium medium ", ";\n    transition-property: transform, border-color;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Active = _styledComponents["default"].hr(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return props.theme.borderWidth;
});

var _default = Active;
exports["default"] = _default;